import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {HelpModule} from "../../components/help/help.module";
import {SettingPage} from "./setting";

@NgModule({
  declarations: [
    SettingPage,
  ],
  entryComponents: [
    SettingPage,
  ],
  imports: [
    IonicPageModule.forChild(SettingPage),
    HelpModule
  ]
})
export class SettingModule {}



// WEBPACK FOOTER //
// ./src/pages/setting/setting.module.ts